import React from 'react';

import Allforms from 'components/Allforms';

export const App = () => {
  return (
    <Allforms />
  );
}
